import { render, staticRenderFns } from "./MinMaxSell.vue?vue&type=template&id=2fb6b6e6&"
import script from "./MinMaxSell.vue?vue&type=script&lang=js&"
export * from "./MinMaxSell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports